import { request, Row, Rows } from './request';
import AppError from './models/common/res/AppError';
import { Reservation } from './models/reservations/res/Reservation';
import { AddReservationBody } from './models/reservations/req/AddReservationBody';
import { ReservationDetail } from './models/reservations/res/ReservationDetail';
import moment from 'moment';
import { RecentReservation } from './models/reservations/res/RecentReservation';
import { ChatbotChannel } from './models/auth/req/ChatbotGuestSignInBody';

export const addReservation = async (body: AddReservationBody, jwt: string) => {
  const url = `/mini-web/reservations`;
  try {
    const { data } = await request<Row<Reservation>>({
      method: 'post',
      url,
      requestBody: body,
      headers: {
        Authorization: jwt,
      },
    });
    const { row } = data;
    return row;
  } catch (e) {
    throw new AppError(e);
  }
};

export const fetchRecentReservations = async (jwt: string) => {
  const url = `/mini-web/recent-reservations`;
  try {
    const { data } = await request<Rows<RecentReservation>>({
      method: 'get',
      url,
      headers: {
        Authorization: jwt,
      },
    });
    const { rows } = data;
    return rows;
  } catch (e) {
    throw new AppError(e);
  }
};

export const fetchReservationHistories = async (jwt: string) => {
  const url = `/mini-web/reservations`;
  try {
    const { data } = await request<Rows<Reservation>>({
      method: 'get',
      url,
      queryParams: {
        page: 1,
        pageSize: 9999,
        noCache: moment().format('YYYYMMDDHHmmss'),
      },
      headers: {
        Authorization: jwt,
      },
    });
    const { rows } = data;
    return rows;
  } catch (e) {
    throw new AppError(e);
  }
};

export const fetchReservationHistoryDetail = async (
  jwt: string,
  id: number,
) => {
  const url = `/mini-web/reservations/${id}`;
  try {
    const { data } = await request<Row<ReservationDetail>>({
      method: 'get',
      url,
      headers: {
        Authorization: jwt,
      },
      queryParams: {
        noCache: moment().format('YYYYMMDDHHmmss'),
      },
    });
    const { row } = data;
    return row;
  } catch (e) {
    throw new AppError(e);
  }
};

export const cancelReservation = async (
  jwt: string,
  reservationId: number,
  languageCode?: string,
  // 예약 푸시 채널 (현재 LINE / RESPOND_IO 만 사용)
  reservationPushChannel?: ChatbotChannel,
  respondIOUserKey?: string,
) => {
  const url = `/mini-web/reservations/${reservationId}/cancel`;
  try {
    await request({
      method: 'put',
      url,
      headers: {
        Authorization: jwt,
      },
      requestBody: {
        languageCode,
        reservationPushChannel,
        respondIOUserKey,
      },
    });
    return;
  } catch (e) {
    throw new AppError(e);
  }
};

export const editReservationDate = async (
  jwt: string,
  reservationId: number,
  reservedAt: string,
  languageCode?: string,
  // 예약 푸시 채널 (현재 LINE / RESPOND_IO 만 사용)
  reservationPushChannel?: ChatbotChannel,
  respondIOUserKey?: string,
) => {
  const url = `/mini-web/reservations/${reservationId}/reservation-date`;
  try {
    await request({
      method: 'put',
      url,
      headers: {
        Authorization: jwt,
      },
      requestBody: {
        reservedAt,
        languageCode,
        reservationPushChannel,
        respondIOUserKey,
      },
    });
    return;
  } catch (e) {
    throw new AppError(e);
  }
};

export const sendReservationCompleteMessage = async (
  partnerId: number,
  jwt: string,

  body: {
    reservationId: number;
    chatLogId: number;
    reservationType: 'REQUEST' | 'MODIFY' | 'CANCEL';
  },
) => {
  const url = `/member/partners/${partnerId}/consultation/reservation-application`;
  try {
    await request({
      method: 'post',
      url,
      headers: {
        Authorization: jwt,
      },
      requestBody: body,
    });
    return;
  } catch (e) {
    throw new AppError(e);
  }
};

export const getUtmQueries = (searchParams: URLSearchParams) => {
  return {
    utmSource: searchParams.get('utm_source') || undefined,
    utmMedium: searchParams.get('utm_medium') || undefined,
    utmCampaign: searchParams.get('utm_campaign') || undefined,
    utmTerm: searchParams.get('utm_term') || undefined,
    utmContent: searchParams.get('utm_content') || undefined,
    utmTarget: searchParams.get('utm_target') || undefined,
    utmChannel: searchParams.get('utm_channel') || undefined,
    utmCreatedAt: searchParams.get('utm_createdAt') || undefined,
    utmPartnerId: searchParams.get('utm_partnerId') || undefined,
    utmEventId: searchParams.get('utm_eventId') || undefined,
    utmProductId: searchParams.get('utm_productId') || undefined,
  };
};
